import post from './post.js';
import get from './get.js';
import CONFIG from '../config.json';

export default {
	list: ({ session, app_uid }) => get('files/list', { session, app_uid }),
	delete: ({ session, app_uid, name }) => post('files/delete', { session, app_uid, name }),

	upload: async ({ session, app_uid, file }) => {
		//TODO emit progress somehow?
		const body = new FormData();
		body.append('file', file);
		body.append('session', session);
		body.append('app_uid', app_uid);

		const response = await fetch(`${CONFIG.api}/files/upload`, {
			method: 'POST',
			body,
		});

		let data;
		try {
			data = await response.json();
		} catch (e) {
			console.error(e);
		}

		if (response.ok) {
			return data;
		} else if (response.status === 400) {
			throw data;
		} else {
			throw 'api_error';
		}
	},
};
